import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './Overlay.scss';

class Overlay extends Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
  };

  render() {
    const {isActive, className} = this.props;
    const activeClass = isActive ? s.active : '';

    return <div className={cx(s.pwaOverlay, className, activeClass)}/>;
  }
}

export default Overlay;
